import { RegionType } from '@wix/shoutout-email-model-v3';
import { get } from 'lodash';
import { getValueOrFallback } from '../../utils/get-value-or-fallback';
import { getMessageWidth } from '../../utils/get-message-width';
import { defaultTextPadding } from '../../utils/defaults';
import * as cssUtils from '../../utils/css-utils';
import { getPxValue } from '../../utils/line-height-to-px';
import { getColumnOfRegion, calculateColumnDesktopDisplayWidth, balanceGapsBetweenColumns, calculateMixContentSpace, } from './utils';
import { getImage } from './get-image';
import { getText } from './get-text';
import { getButton } from './get-button';
export const getMixSection = ({ composerData, css, experiments, isRtl, region, manipulateHtml, replaceImagePlaceholders, }) => {
    if (region.type !== RegionType.Mix) {
        throw Error('Mix must be passed');
    }
    const userSpacingsOverrides = get(region, 'data.styles.spacings');
    const spacerHeight = userSpacingsOverrides?.horizontalSpacing ||
        getValueOrFallback(composerData, 'styles.css.so-global-region-mix-separator.marginBottom', '32px');
    const messageContentWidth = getMessageWidth(composerData, css);
    const numberOfColumns = region.data.layout.rows[0].columns.length;
    const verticalSpacing = userSpacingsOverrides?.verticalSpacing
        ? parseInt(userSpacingsOverrides?.verticalSpacing, 10)
        : null;
    const balancedColumnPaddings = balanceGapsBetweenColumns(parseInt(verticalSpacing === null
        ? getValueOrFallback(css, 'so-global-region-mix-left.paddingRight', defaultTextPadding)
        : Math.floor(verticalSpacing / 2.0), 10), parseInt(verticalSpacing === null
        ? getValueOrFallback(css, 'so-global-region-mix-right.paddingLeft', defaultTextPadding)
        : Math.ceil(verticalSpacing / 2.0), 10), numberOfColumns);
    const leftColumnPadding = balancedColumnPaddings.right;
    const rightColumnPadding = balancedColumnPaddings.left;
    const userOverrides = get(region, 'data.styles.region');
    const rules = [
        userOverrides,
        css['so-global-region-mix'],
        css['so-global-region'],
    ];
    const visibility = get(region, 'data.visibility');
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, false, visibility);
    const outerPadding = cssUtils.margin(rules);
    const innerPadding = cssUtils.padding(rules);
    const columnsWidths = calculateColumnDesktopDisplayWidth({
        columns: region.data.layout.rows[0].columns,
        messageContentWidth,
        outerPadding,
        innerPadding,
        leftColumnPadding,
        rightColumnPadding,
        isRtl,
    });
    const regions = region.data.regions.map((regionDefinition) => {
        if (regionDefinition.type === 'text') {
            return getText({
                region: regionDefinition,
                css,
                composerData,
                experiments,
                isRtl,
                manipulateHtml,
            });
        }
        if (regionDefinition.type === 'image') {
            let colWidth = region.data.layout.rows[0].columns.find((col) => col.regionIds.includes(regionDefinition.regionId))?.width;
            if (colWidth === 0) {
                colWidth = 50;
            }
            return getImage({
                region: regionDefinition,
                composerData,
                getColumnOfRegion: getColumnOfRegion(region, regionDefinition),
                numberOfColumns,
                columnWidth: colWidth,
                balancedColumnPaddings,
                userOverrides: userOverrides,
                replaceImagePlaceholders,
            });
        }
        if (regionDefinition.type === 'button') {
            const contentSpace = calculateMixContentSpace({
                numberOfColumns,
                messageContentWidth,
                outerPadding,
                innerPadding,
                leftColumnPadding,
                rightColumnPadding,
            });
            const columns = region.data.layout.rows[0].columns;
            const columnWidth = columns.find((col) => col.regionIds.includes(regionDefinition.regionId))
                ?.width || 50;
            const spaceForColumn = contentSpace * (columnWidth / 100);
            return getButton({
                region: regionDefinition,
                css,
                isRtl,
                experiments,
                mixData: region,
                columnWidthPx: spaceForColumn,
            });
        }
        return null;
    });
    return {
        widthsForMediaQueries: columnsWidths.map((column) => column.displayWidth),
        regions,
        columnsWidths,
        layout: region.data.layout,
        noWrap: region.data.noWrap,
        leftColumnPadding: getPxValue(leftColumnPadding),
        rightColumnPadding: getPxValue(rightColumnPadding),
        spacerHeight: getPxValue(spacerHeight),
        outerPadding,
        innerPadding,
        cssClass: mobileCssClass,
        visibility,
    };
};
//# sourceMappingURL=get-mix-section.js.map